<template>
  <div
    id="stepper-navbar"
    class="row d-flex justify-content-center align-items-center mx-1"
  >
    <div class="w-100">
      <div class="text-dark">
        <div class="d-flex justify-content-center align-items-center">
          <ul id="stepper-progress" class="w-100 steps">
            <li
              v-for="(titleLabel, idx) in tabList"
              :key="`step-${idx}`"
              class="step font-medium-5"
              :class="{ 'step-active': stepActive >= idx }"
            >
              <div>
                <div>
                  {{ titleLabel }}
                </div>
                <div
                  class="inprogress-wrp"
                  v-if="
                    checkFormData && stepActive == idx && formData.status == 1
                  "
                >
                  <div class="title-inprogress">กำลังดำเนินการ</div>
                </div>
                <div
                  class="success-wrp"
                  v-if="formData.isConfirm && stepActive !== idx && idx !== 1 && formData.status == 1"
                >
                  <div class="title-success">สำเร็จ</div>
                </div>
                <div
                  class="success-wrp"
                  v-if="formData.status == 5 || formData.status == 9"
                >
                  <div class="title-success">สำเร็จ</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, reactive, watch } from "@vue/composition-api";
export default {
  props: {
    stepActive: { type: Number, default: 0 },
    tabList: { type: Array, default: [] },
    formData: { type: Object, default: {} },
  },
  setup(props) {
    const formDataObj = reactive({
      inprogress: false,
    });

    const checkFormData = computed(() => {
      return (
        props.formData.totalPoint ||
        props.formData.totalSpending ||
        props.formData.docNo ||
        props.formData.receiptNo ||
        props.formData.storeName ||
        props.formData.remark1 ||
        props.formData.remark2 ||
        props.formData.itfRef1 ||
        props.formData.itfRef2 ||
        props.formData.itfExtra
      );
    });

    return {
      checkFormData,
      formDataObj,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/document-detail/step-navbar.css";
</style>
